import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=b6815eea&"
import script from "./InputWithLabel.vue?vue&type=script&lang=js&"
export * from "./InputWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./InputWithLabel.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports